<template>
  <div class="flex flex-col gap-y-5 overflow-hidden">
    <ul class="flex items-center gap-x-5">
      <c_cell title="关键字">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <c_cell title="乙方单位">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <c_cell title="所属分会">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
          ></el-input>
        </template>
      </c_cell>
      <el-button type="primary" @click="onLoad">搜索</el-button>
      <div class="flex justify-end flex-1">
        <el-button type="primary" link icon="Plus" @click="state.showAdd = true"
          >添加虚拟项</el-button
        >
      </div>
    </ul>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      max-height="65vh"
      border
      style="border-color: #f00"
    >
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="所属分会" label2="乙方单位" />
        </template>
        <template #default="{ row }">
          <c_tabgroup :value1="row.hcmc">
            <template #bottom>
              <text>{{ row.jfmc }}</text>
              <text class="text-gray-400 text-xs">{{ row.jfbh }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="采购名称" label2="供应商" />
        </template>
        <template #default="{ row }">
          <c_tabgroup :value1="row.mc">
            <template #bottom>
              <text>{{ row.gysmc }}</text>
              <text class="text-gray-400 text-xs">{{ row.gysbh }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="采购项" label2="规格" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>[{{ row.lx }}]</text>
              <strong>{{ row.mc }}</strong>
            </template>
            <template #bottom>
              <text>{{ row.gg }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column
        label="采购单价"
        prop="cgdj"
        align="right"
        :width="100"
        :formatter="$tab_PriceFormat"
      />
      <el-table-column
        label="采购价合计"
        align="right"
        prop="cghj"
        :width="100"
        :formatter="$tab_PriceFormat"
      />
      <el-table-column label="备注" :width="260">
        <template #default="{ row }">
          <el-input v-model="row.remark" @focus="$onFocus" />
        </template>
      </el-table-column>
      <el-table-column align="center" :width="200">
        <template #header>
          <div class="flex items-center gap-x-1 justify-center">
            <div class="c-table-col-header" label1="数量" label2="天数"></div>
            <el-tooltip
              placement="top"
              effect="dark"
              content="天数=租赁设备的使用天数"
            >
              <el-icon class="cursor-pointer"><QuestionFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
        <template #default="{ row }">
          <div class="grid grid-cols-2 gap-x-1">
            <el-input-number
              v-model="row.num"
              controls
              controls-position="right"
              class="!w-full tab-input-number"
              placeholder="数量"
              @focus="$onFocus"
            />
            <el-input-number
              v-model="row.days"
              precision="0"
              controls
              controls-position="right"
              class="!w-full tab-input-number"
              placeholder="天数"
              @focus="$onFocus"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="报账单价"
        prop="sksm"
        :formatter="$tab_TextFormat"
        align="center"
        :width="140"
      >
        <template #default="{ row }">
          <el-input-number
            v-model="row.dj"
            class="!w-full"
            precision="2"
            placeholder="报账单价"
            @focus="$onFocus"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        prop="je"
        :formatter="$tab_MoneyFormat"
        :width="140"
      >
        <template #header>
          <div class="flex items-center gap-x-1 justify-end">
            <li>报账金额</li>
            <el-tooltip
              placement="top"
              effect="dark"
              content="报账金额=报账单价*数量*天数"
            >
              <el-icon class="cursor-pointer mb-1"><QuestionFilled /></el-icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="state.showAdd"
      title="添加虚拟项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showAdd = false;
        }
      "
      width="90%"
    >
      <c_add
        @close="
          (refresh) => {
            state.showAdd = false;
            if (refresh) onLoad();
          }
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import c_add from "./Add/Info.vue";
export default {
  components: { c_add },
  props: {
    id: Number,
    search: Boolean,
  },
  setup(props) {
    const state = reactive({
      params: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      state.list_data = [];

      for (let index = 0; index < 30; index++) {
        state.list_data.push({
          id: index + 1,
          hcmc: "主会场",
          jfmc: "北京华宇国际大酒店",
          jfbh: "1001",
          mc: "会议桌",
          gysmc: "北京华宇国际大酒店",
          gysbh: "1001",
          lx: "桌椅",
          mc: "会议桌",
          gg: "长1.5米，宽0.8米",
          hj: "1000",
          cgdj: 100,
          dj: "1000",
          sl: "10",
          dw: "张",
          bz: "无",
          sksm: "1000",
          ts: "10",
          je: 1000,
        });
      }
    };
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
